export default "__VITE_PUBLIC_ASSET__3323b560__"